/* IMS Constants */

export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const ADD_PROFILE = 'ADD_PROFILE';
